export const MANUAL_CATALOG_FORM_ID = "create-manual-catalog-form";
export const AUTO_CATALOG_FORM_ID = "create-auto-catalog-form";
